import moment from 'moment';

export const timeFormat = 'HH:mm';
export const dateFormat = 'DD.MM.YYYY';
// Полис ОСАГО не может быть законцен раньше чем сегодня
export const start_date = value => {
  return value.format('x') < moment().format('x') - 43000;
};
export function isEmptyObject(obj) {
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      return false;
    }
  }
  return true;
}

export function config(valueFromRedux, required = false, validator = null) {
  if (valueFromRedux) {
    if (Array.isArray(valueFromRedux)) {
      return {
        initialValue: valueFromRedux,
        validate: [
          {
            trigger: 'onChange',
            rules: [
              { type: 'array', message: 'is not arrray' },
              {
                required: required,
                message: 'Поле, обязательное для заполнения',
              },
            ],
          },
        ],
      };
    } else {
      return {
        initialValue: String(valueFromRedux),
        validate: [
          {
            trigger: 'onChange',
            rules: [
              {
                required: required,
                message: 'Поле, обязательное для заполнения',
              },
              { validator: validator && validator },
            ],
          },
        ],
      };
    }
  } else {
    return {
      validate: [
        {
          trigger: 'onChange',
          rules: [
            {
              required: required,
              message: 'Поле, обязательное для заполнения',
            },
            { validator: validator },
          ],
        },
      ],
    };
  }
}
export function configEmail(valueFromRedux, required = true) {
  if (valueFromRedux) {
    return {
      initialValue: valueFromRedux,
      validate: [
        {
          trigger: 'onChange',
          rules: [
            {
              required: required,
              message: 'Поле, обязательное для заполнения',
            },
            { type: 'email', message: 'Не корректный e-mail' },
          ],
        },
      ],
    };
  } else {
    return {
      validate: [
        {
          trigger: 'onChange',
          rules: [
            {
              required: required,
              message: 'Поле, обязательное для заполнения',
            },
            { type: 'email', message: 'не корректный e-mail' },
          ],
        },
      ],
    };
  }
}

export function configTimePicker(pickerFieldFromRedux, required = false) {
  if (pickerFieldFromRedux) {
    return {
      initialValue: moment(pickerFieldFromRedux, 'HH:mm'),
      rules: [
        {
          type: 'object',
          required: required,
          message: 'Выберите время',
          trigger: 'onBlur',
        },
      ],
    };
  } else {
    return {
      rules: [
        {
          type: 'object',
          required: required,
          message: 'Выберите время',
          trigger: 'onBlur',
        },
      ],
    };
  }
}

export function configPicker(pickerFieldFromRedux, required = false) {
  if (pickerFieldFromRedux) {
    return {
      initialValue: moment(pickerFieldFromRedux),
      rules: [
        {
          type: 'object',
          required: required,
          message: 'Выберите дату',
          trigger: 'onBlur',
        },
      ],
    };
  } else {
    return {
      rules: [
        {
          type: 'object',
          required: required,
          message: 'Выберите дату',
          trigger: 'onBlur',
        },
      ],
    };
  }
}

export function configNumberLen(valueFromRedux, required = false, min) {
  if (valueFromRedux) {
    return {
      initialValue: String(valueFromRedux),
      validate: [
        {
          trigger: 'onChange',
          rules: [
            {
              required: required,
              message: 'Поле, обязательное для заполнения',
            },
            { min: min, message: 'недостаточно цифр' },
          ],
        },
      ],
    };
  } else {
    return {
      validate: [
        {
          trigger: 'onChange',
          rules: [
            {
              required: required,
              message: 'Поле, обязательное для заполнения',
            },
          ],
        },
      ],
    };
  }
}
export function configPatternLen(
  valueFromRedux = '',
  required = false,
  pattern = /\d+/,
  message = 'недостаточно цифр'
) {
  if (valueFromRedux) {
    return {
      initialValue: String(valueFromRedux),
      validate: [
        {
          trigger: 'onChange',
          rules: [
            {
              required: required,
              message: 'Поле, обязательное для заполнения',
            },
            { pattern: pattern, message: message },
          ],
        },
      ],
    };
  } else {
    return {
      validate: [
        {
          trigger: 'onChange',
          rules: [
            {
              required: required,
              message: 'Поле, обязательное для заполнения',
            },
          ],
        },
      ],
    };
  }
}

export function configShort(valueFromRedux, required = true) {
  if (valueFromRedux) {
    return {
      initialValue: String(valueFromRedux),
      validate: [
        {
          trigger: 'onChange',
          rules: [{ required: required, message: 'Заполните' }],
        },
      ],
    };
  } else {
    return {
      validate: [
        {
          trigger: 'onChange',
          rules: [{ required: required, message: 'Заполните' }],
        },
      ],
    };
  }
}

export const parseBrandName = (arr, id) => {
  let name;
  try {
    name = arr.filter(record => String(record.vehicleBrandId) === String(id))[0]
      .brandName;
  } catch (error) {
    alert(error);
  }
  return name;
};

export const formatterMask = (value, mask) => {
  let i = 0;
  let lastReplacedIndex = -1;
  const filledMask = mask.replace(/#/g, (_, index) => {
    if (i >= value.length) {
      return ' ';
    }
    lastReplacedIndex = index;
    return value[i++];
  });
  return filledMask.substring(0, lastReplacedIndex + 1);
};

export const normalizeDate = form => {
  Object.keys(form).forEach(element => {
    if (form[element] instanceof moment) {
      form[element] = moment(form[element]).format('YYYY-MM-DD');
    }
  });
  return form;
};

export const getPrefix = rowNum => {
  let num = String(rowNum);
  let result;
  if (num.endsWith('1')) {
    result = `${num} год`;
  } else if (num.endsWith('2') || num.endsWith('4') || num.endsWith('3')) {
    result = `${num} года`;
  } else {
    result = `${num} лет`;
  }
  return result;
};
